import gql from 'graphql-tag';

// Returns the magazine root of a page (exactly one of parent_folder_id or
// parent_project_id is set, per the schema's single_page_parent constraint).
// Used to scope Tailwind CSS rebuilds after unpublish / delete / move actions
// where the page HTML is not needed but the magazine's parent ID is.
export default gql`
query getPageParentIds($pageId: Int!) {
  pages_by_pk(page_id: $pageId) {
    page_id
    parent_folder_id
    parent_project_id
  }
}
`;
